const Error = () =>{
    return(
        <div>
            <h2>Page does not exist</h2>
        </div>
    )
}

export default Error